import React, { useEffect, useState } from 'react'
import TextFieldUniversal from '../../../../../../../validate/form/text/TextFieldUniversal'

const ReceivedCountField = ({ item, required, setValidate, setValueForm, forciblyValue }) => {

	const [value, setValue] = useState('')
	const [forciblyError, setForciblyError] = useState('')

	useEffect(() => {
		checkValidCount()
	}, [item, value])

	const checkValidCount = () => {
		const valueTemp = Number(value.replace(',', '.'))
        if (item.count < valueTemp) {
			setForciblyError('Значення не може бути більше за загальну кількість')
		} else {
			setForciblyError('')
		}
    }

  return (
    <TextFieldUniversal
        value={value}
        setValue={e => {
            setValueForm(e)
            setValue(e)
        }}
        setValidate={setValidate}
        label={'Кількість'} 
        placeholder={'1'}
        validates={{
            isEmpty: true,
            // isDigit: true
            isNumber: true
        }}
        forciblyValue={forciblyValue}
        required={required}
		forciblyError={forciblyError}
        // classNameAdd={'w200'}
		
    />
  )
}

export default ReceivedCountField